"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const POINT_REASON = {
    'new-user-bonus': 'Bonus untuk pengguna baru',
    'check-in-bonus': 'Bonus untuk check-in',
    'package-bonus': 'Bonus untuk bergabung membership',
    'store-bonus': 'Bonus untuk pembelian barang di EVOS SHOP/METAZONE',
    'store-use': 'Penggunaan poin untuk pembelian barang',
    'milestone-bonus': 'Bonus milestone',
    'unique-code-bonus': 'Bonus penggunaan kode unik',
    'referral-bonus': 'Bonus penggunaan referral',
    'register-cup': 'Bonus untuk registrasi EFC',
    'verified-phone-number': 'Bonus untuk verifikasi no HP',
    'other-bonus': 'Bonus lain-lain'
};
exports.default = POINT_REASON;
